export interface TextAnswerQuestion {
  answer?: number;
  tolerance?: number;
  tolerancePercent?: number;
  unit?: string;
  accepted?: string[];
  keywords?: string[];
  maxLength?: number;
}

// Единая нормализация ответов и ключевых слов.
export function normalizeAnswer(s: string): string {
  return s.trim().toLowerCase().replace(/ё/g, 'е')
    .replace(/[\p{Quotation_Mark}\p{Dash_Punctuation}−`]/gu, '')
    .replace(/\s+/g, ' ').replace(/[\p{P}\s]+$/gu, '').trim();
}

export function parseNumber(s: string): number | null {
  if (typeof s !== 'string') return null;
  const text = s.replace(/\s/g, '').replace(',', '.');
  if (!/^[+-]?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i.test(text)) return null;
  const value = Number(text);
  return Number.isFinite(value) ? value : null;
}

export function validNumberQuestion(q: Pick<TextAnswerQuestion, 'answer' | 'tolerance' | 'tolerancePercent' | 'unit'>): boolean {
  return typeof q.answer === 'number' && Number.isFinite(q.answer)
    && [q.tolerance, q.tolerancePercent].every(n => n === undefined || (typeof n === 'number' && Number.isFinite(n) && n >= 0))
    && (q.unit === undefined || typeof q.unit === 'string');
}

export function validFreeQuestion(q: Pick<TextAnswerQuestion, 'accepted' | 'keywords' | 'maxLength'>): boolean {
  const validList = (list: unknown) => list === undefined || (Array.isArray(list)
    && list.every(s => typeof s === 'string' && !!normalizeAnswer(s)));
  return validList(q.accepted) && validList(q.keywords)
    && (q.accepted?.length ?? 0) <= 10
    && ((q.accepted?.length ?? 0) > 0 || (q.keywords?.length ?? 0) > 0)
    && (q.maxLength === undefined || (Number.isInteger(q.maxLength) && q.maxLength >= 1 && q.maxLength <= 300));
}

